/**
 * Shared footer — use on Landing and any other public page with a footer.
 */
export function Footer() {
  return (
    <footer className="border-t border-border py-8 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
        <div>© 2026 StoryMint. All rights reserved.</div>
        <div className="flex gap-6">
          <a href="/terms" className="hover:text-foreground transition-colors">
            Terms
          </a>
          <a href="/privacy" className="hover:text-foreground transition-colors">
            Privacy
          </a>
        </div>
      </div>
    </footer>
  );
}
